export default "assets/images/slider-arrow-ea91ac51.svg";